import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightningIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "url(#pet__paint0_linear_21052_28617)",
		d: "M4.05482 9.98441L6.51493 2.87329C6.68876 2.37427 7.24262 2 7.78467 2L13.4763 2C13.9845 2 14.3387 2.40546 14.2393 2.87329C14.2194 2.96686 14.1656 3.06043 14.1119 3.154L11.738 6.99025L16.4471 6.99025C17.1247 6.99025 17.588 7.52047 17.4554 8.14425C17.4023 8.39376 17.2543 8.61209 17.079 8.79922L8.71142 17.5634C8.45511 17.8129 8.07655 18 7.73776 18H7.63612C7.09406 18 6.7737 17.5945 6.87978 17.0955C6.89303 17.0331 6.91292 16.9396 6.96006 16.8772L9.80532 10.9825L4.92679 10.9825C4.31698 10.9825 3.93549 10.5458 4.05482 9.98441Z"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "pet__paint0_linear_21052_28617",
		x1: 12.2567,
		x2: 12.2567,
		y1: 2,
		y2: 18,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFD336" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FF2318"
		})]
	}) })]
});
const ForwardRef = forwardRef(SvgLightningIcon);
export default ForwardRef;
